import React from "react";
import {PublicClientApplication} from "@azure/msal-browser";
import {connect} from "react-redux";
import {IRootState} from "../store";
import CDBNav from "./CDBNav";
import {CDBMain} from "./CDBMain";
import LoadingCard from "./LoadingCard";

interface HandleMsalRedirectProps
{
    msalInstance: PublicClientApplication;
}

interface HandleMsalRedirectState
{
    finishedHandlingRedirect: boolean;
}

class HandleMsalRedirect extends React.Component<HandleMsalRedirectProps,HandleMsalRedirectState> {
    constructor(props: HandleMsalRedirectProps) {
        super(props);
        
        this.state = 
        {
            finishedHandlingRedirect: false 
        };
    }
    
    componentDidMount() {
        
        this.props.msalInstance.handleRedirectPromise().then((r) => {
            this.setState({finishedHandlingRedirect: true});
            return r;
        })
    }
    
    render() {
        if(this.state.finishedHandlingRedirect)
        {
            return this.props.children;
        }
        else
        {
            return (
                <div className={"cdb-admin"}>
                    <div className={"cdb-admin-school-selector"}></div>
                    <CDBNav/>
                    <CDBMain>
                        <LoadingCard text={"Signing in"}/>
                    </CDBMain>
                </div>
            )
        }
    }
}

export default connect(
    (state: IRootState): HandleMsalRedirectProps => {
        return {
            msalInstance: state.auth.msalInstance
        };
    }
)(HandleMsalRedirect);